(() => {
  const key = '__bisAfterConfiguratorInit';
  if (window[key]) { window[key](document); return; }
  function init(scope) {
    const roots = [];
    if (scope.matches?.('[data-bis-after-configurator]')) roots.push(scope);
    roots.push(...scope.querySelectorAll('[data-bis-after-configurator]'));
    roots.forEach(root => {
      if (root.dataset.bisReady === 'true') return;
      root.dataset.bisReady = 'true';
      const tabs = Array.from(root.querySelectorAll('[role="tab"]'));
      function activate(tab) {
        tabs.forEach(item => {
          const selected = item === tab;
          item.setAttribute('aria-selected', String(selected));
          item.tabIndex = selected ? 0 : -1;
          const panel = root.querySelector('[id="' + item.getAttribute('aria-controls') + '"]');
          if (panel) panel.hidden = !selected;
        });
      }
      tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => activate(tab));
        tab.addEventListener('keydown', event => {
          let next;
          if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
          if (event.key === 'ArrowLeft') next = (index - 1 + tabs.length) % tabs.length;
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = tabs.length - 1;
          if (next !== undefined) { event.preventDefault(); activate(tabs[next]); tabs[next].focus(); }
        });
      });
    });
  }
  window[key] = init;
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document), {once:true});
  else init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
